export enum QuoteSuppItemStatusEnum {
  Pending = 1,
  Answered = 2,
  Cart = 3,
  Unavailable = 4
}
